<template>
  <div class="dtlist">
    <!-- 头部 -->
    <hearderCommon :text="textT"></hearderCommon>
    <!-- 选择配送地址 -->
    <div class="dispatch">
      <div class="senl">{{ DtList.status | filterLabel(statusList) }}</div>
      <van-cell>
        <div>
          <van-row
            gutter="20"
            class="orders-van-row"
            style="padding: 0; padding-bottom: 5px"
          >
            <van-col span="8" class="orders-van-col">配送地址</van-col>
          </van-row>
          <van-row gutter="20" class="orders-van-row" style="padding: 0">
            <van-col span="8" class="orders-van-col chose">{{
              DtList.deliveryName
            }}</van-col>
          </van-row>
        </div>
      </van-cell>

      <van-cell class="orders-time" style="padding: 0; padding-bottom: 0px">
        <van-row gutter="20" class="orders-van-row oddr">
          <van-col span="8" class="orders-van-col">配送日期</van-col>
        </van-row>
        <van-cell class="lateDay">{{ DtList.deliveryTime | dateFil }}</van-cell>
      </van-cell>

      <van-cell class="orders-time" style="padding: 0; padding-bottom: 0px">
        <van-row gutter="20" class="orders-van-row oddr">
          <van-col span="8" class="orders-van-col">订单类型</van-col>
        </van-row>
        <van-cell class="lateDay"
          ><span class="chose">{{ DtList.customerOrderType }}</span></van-cell
        >
      </van-cell>
    </div>

    <!-- 订单号 -->
    <div class="ordersNum">订单{{ DtList.orderCode }}</div>
    <!-- 订单列表 -->
    <div class="ordersList" style="position: relative; padding-bottom: 90px">
      <div
        class="goodList"
        v-for="index in DtList.children"
        :key="index.cartId"
      >
        <div class="ty-top">
          <img
            :src="index.picUrl"
            alt
            style="object-fit: cover; margin-right: 5px"
            @click="goDetails(index.goodsId, DtList.goodsKindValue)"
          />
          <p
            class="text1"
            @click="goDetails(index.goodsId, DtList.goodsKindValue)"
          >
            {{ index.goodsName }}
          </p>
          <br />
          <div class="bt-div">
            <!-- 订单详情取值错误 -->
            <div class="weight">
              <!-- ￥{{ (index.salePrice / index.saleRatio).toFixed(2) }}/{{
                index.goodsUnitLabel
              }} -->
              --/{{ index.goodsUnitLabel }}
            </div>
          </div>
            <div class="text3" v-if="index.orderQty == (index.deliveryQty -index.diffQty)">
            <span class="ty-left">
              <!-- ￥{{index.confirmPrice}} / {{ index.saleUnitLabel | filterUnit(index.saleRatio ,index.goodsUnitLabel)}} -->
              -- / {{ index.saleUnitLabel | filterUnit(index.saleRatio ,index.goodsUnitLabel)}}
            </span>
            <span class="ty-right">
                <span class="dt-col-le">订/{{index.orderQty}}</span>
                <span class="dt-col-ri">收/{{index.deliveryQty-index.diffQty}}</span>
            </span>
          </div>
          <div class="van-ellipsis">
            <van-row
              class="dt-diff"
              v-if="index.orderQty != index.deliveryQty - index.diffQty"
              type="flex"
              justify="space-between"
            >
              <van-col span="12">
                <span
                  class="lin-th"
                  v-if="index.actualPrice != index.confirmPrice"
                  >¥{{ index.actualPrice }}</span
                >
                <span class="lin-th-r">
                  ￥{{ index.confirmPrice }}/{{ index.saleUnitLabel }}
                  <span
                    v-if="
                      index.saleRatio != 1 ||
                      index.goodsUnitLabel != index.saleUnitLabel
                    "
                    >({{ index.saleRatio }}{{ index.goodsUnitLabel }})</span
                  >
                </span>
              </van-col>
              <van-col span="8">
                <span class="dt-col-le">订/{{ index.orderQty }}</span>
                <span class="dt-col-ri"
                  >收/{{ index.deliveryQty - index.diffQty }}</span
                >
              </van-col>
            </van-row>
          </div>
          <!-- 备注 -->
          <div class="remark van-ellipsis" v-if="index.remark">
            备注：{{ index.remark }}
          </div>
        </div>
      </div>
    </div>
    <!-- 
      :price="totalPrice" -->
    <van-submit-bar
      button-text="提交订单"
      tip-icon="warning"
      tip="最终结算金额以最终送货单为准"
      safe-area-inset-bottom
      button-type="info round"
    >
      <div class="orders-submit-bar">共{{ orderListLength }}件</div>
      <div class="div-btn">
        <van-button
          type="primary"
          size="small"
          class="send-btn btn-right"
          plain
          round
          @click="reap"
          :disabled="DtList.goodsKindValue == '1'"
          v-if="DtList.status == 20"
          >确定收货</van-button
        >
      </div>
    </van-submit-bar>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";
export default {
  created() {
    this.orderId = this.$route.query.orderId;
    this.customerId = localStorage.getItem("customerId");
    this.query();
  },
  data() {
    return {
      DtList: {},
      priceList: [],
      customerId: "",
      textT: "补货单详情", 
       statusList: [
        { text: "待发货", value: 10, label: "待发货" },
        { text: "待收货", value: 20, label: "待收货" },
        { text: "待对账", value: 30, label: "待对账" },
        { text: "交易成功", value: 40, label: "交易成功" },
        { text: "交易关闭", value: 100, label: "交易关闭" },
      ],
    };
  },
  methods: {
    // 回退
    ListBack() {
      window.history.back();
    },
    query() {
      this.$axios.get(`/trade/supplementCargo/${this.orderId}`).then((res) => {
        this.DtList = res.data.data;
        this.priceList = res.data.data.children;
      });
    },
    // 确认收货
    reap() {
      this.$dialog
        .confirm({
          message: "确定收货吗",
          confirmButtonColor: "#74b42b",
        })
        .then(() => {
          this.$axios
            .get(`/trade/supplementCargo/receive/${this.orderId}`)
            .then((res) => {
              if (res.data.code == 0) {
                this.$toast("收货 成功");
                this.$router.go({path:'/expense/list'})
                // this.query();
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 去商品详情页
    goDetails(goodsId, goodsKindValue) {
      if (goodsKindValue == "0") {
        this.$router.push({
          path: "/details",
          query: {
            goodsId: goodsId,
          },
        });
      }
    },
  },
  computed: {
    // 合计价格
    totalPrice() {
      return this.priceList.reduce((price, item) => {
        price += item.totalPrice * 100;
        return price;
      }, 0);
    },
    // 总件数
    orderListLength() {
      return this.priceList.length;
    },
  },
  components: {
    hearderCommon,
  },
};
</script>

<style scoped>
.height {
  height: 100%;
}
.dtlist {
  background: rgba(242, 242, 242, 1);
  padding-top: 32px;
}
.order-header-back {
  width: 80px;
}
header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10009;
}

.van-cell:not(:last-child)::after {
  height: 10px;
  width: 90%;
}
.header {
  background: rgba(237, 237, 237, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  position: relative;
  padding-left: 30px;
}
.i {
  position: absolute;
  top: 13px;
  left: 10px;
}
.dispatch {
  position: relative;
  margin: 18px auto 6px;
  width: 95%;
  background-color: #fff;
  border-radius: 8px !important;
}
.van-cell {
  background-color: transparent !important;
}
.van-cell--clickable {
  border-radius: 8px;
}
.van-cell__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 7px;
}
.van-cell__right-icon {
  position: absolute;
  top: 45%;
  right: 7%;
}
.van-cell__title {
  border-bottom: 1px dashed #999;
}
.orders-van-row {
  padding-left: 16px;
  padding-bottom: 10px;
}
.oddr {
  padding-bottom: 0px;
}
.orders-van-col {
  font-size: 12px;
  position: relative;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.ordersNum {
  padding-left: 3%;
  line-height: 32px;
  background: rgba(237, 237, 237, 1);
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
}
.ty-top {
  width: 90%;
  position: relative;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 2%;
  border-radius: 10px;
  padding: 10px;
  padding-left: 10px;
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
  overflow: hidden;
}
.sign {
  position: absolute;
  padding-left: 20px;
  box-sizing: border-box;
  right: 0;
  width: 90px;
  height: 24px;
  line-height: 24px;
  background: linear-gradient(
    90deg,
    rgba(116, 180, 43, 0) 0%,
    rgba(116, 180, 43, 0.5) 22%,
    rgba(116, 180, 43, 1) 100%
  );
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 2px;
}
.place1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.place2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
  margin: 5px 0;
}
.time1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.time2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.ty-center {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  background: rgba(237, 237, 237, 1);
  padding-left: 5%;
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
}
img {
  float: left;
  width: 80px;
  height: 88px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
}
.text1 {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.text2 {
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
}
.weight {
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
  float: left;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 21px;
  border-radius: 10%;
}
.ty-left {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 22px;
}
.ty-right {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  float: right;
}
.text3 {
  margin: 5px 0 10px;
  padding-left: 80px;
  padding-right: 3px;
}
.remark {
  margin-top: 50px;
  width: 95%;
  margin: 0 auto;
  background: rgba(102, 102, 102, 0.05);
  border-radius: 8px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding-left: 10px;
}
.orderList >>> .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList >>> .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar__button {
  margin-left: 3%;
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
  display: none;
}
.orderList >>> .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList >>> .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar {
  background-color: rgba(237, 237, 237, 1);
}
.van-submit-bar__bar {
  padding-left: 3%;
}
.van-submit-bar__tip {
  padding: 2px 16px;
  background-color: rgba(245, 166, 35, 0.1);
}
.van-submit-bar__price {
  color: rgba(245, 166, 35, 1);
  font-size: 18px;
}
.orders-submit-bar {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.orders >>> .van-picker__confirm,
.orders >>> .van-picker__cancel {
  color: #74b42b !important;
}
.chose {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  font-size: 16px;
}
.lateDay >>> .van-cell__value,
.van-cell__value--alone {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.lateDay .van-cell__right-icon {
  top: 17%;
}
.lateDay {
  padding-top: 3px;
}
.bt-div {
  width: 100%;
  height: 30px;
}
.lin-th {
  text-decoration: line-through;
  font-size: 14px;
  margin-right: 4px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
.lin-th-r {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 20px;
}
.dt-col-le {
  font-size: 12px;
  margin-right: 6px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.dt-col-ri {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.senl {
  position: absolute;
  width: 80px;
  background: linear-gradient(
    90deg,
    rgba(116, 180, 43, 0) 0%,
    rgba(116, 180, 43, 0.5) 22%,
    rgba(116, 180, 43, 1) 100%
  );
  border-radius: 2px;
  z-index: 999;
  top: 7%;
  right: 0;
  line-height: 22px;
  padding-left: 10px;
  font-size: 12px;
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
/* .van-submit-bar__button[data-v-cdf2ed9c] {
  display: none;
} */
/* .van-submit-bar__button {
  display: none;
} */
.van-submit-bar__text {
  margin-right: 25%;
}
.send-btn {
  float: right;
}
.btn-left {
  border: 1px solid #666;
  color: #666 !important;
}
.btn-right {
  right: 2%;
  border: 1px solid #74b42b;
  color: #74b42b !important;
}
.div-btn {
  position: absolute;
  right: 3%;
}
.change-btn {
  padding: 0 20px;
}
.van-icon-arrow-left {
  top: 11.5px;
}
</style>